import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/decor/',
    component:layout,
    children:[
        {name: 'H5装修', path: 'h5', component: ()=>_import('h5')},
		{name: 'PC装修', path: 'pc', component: ()=>_import('pc')},
		{name: '投保指南', path: 'insureGuide', component: ()=>_import('insureGuide')},
		{name: '理赔指南', path: 'claimsGuide', component: ()=>_import('claimsGuide')},
        // add route here
    ]
}